<template>
  <div class="productcenter">
    <div class="bg">
      <img
        src="@imgs/cpzx.png"
        width="195px"
        height="92px"
        alt=""
        class="cpzx"
      />
    </div>
    <div class="prolist">
      <div class="proitem" v-for="item in proList" :key="item.id">
        <img class="img-width" :src="item.img" alt="" />
        <p>{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      proList: [
        { id: 0, img: require("@imgs/aj.jpg"), title: "阿胶" },
        { id: 1, img: require("@imgs/kcn.jpg"), title: "咳喘宁" },
        { id: 2, img: require("@imgs/zyjp.jpg"), title: "竹叶椒片" },
        { id: 3, img: require("@imgs/ajhm.jpg"), title: "氨咖黄敏胶囊" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.productcenter {

  .prolist {
    width: 960px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 30px;
    .proitem {
      background: #ffffff;
      border: 1px solid #cccccc;
      // margin: 13.5px 0;
      margin-bottom: 30px;
      padding: 0 10px;

      img {
        width: 200px;
        height: 180px;
      }
    }
  }
}
</style>